export default __webpack_public_path__ + "video-play-square-button.png";